import { DmTreeNodeWithChildren } from '../types';

export function getChildrenForNode<TNode extends DmTreeNodeWithChildren>(
  _node: TNode
): TNode['children'] | undefined {
  // add cache reading logic
  throw new Error('Not implemented');
}
